import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
export default function downloadBlob(blob, fileName) {
  var url = URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  // Deferred rather than synchronous: revoking the URL immediately after
  // click() is flaky in Firefox, which can still be reading it.
  setTimeout(function () {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  });
}